{
  "access-denied-user": "El usuario introducido no puede acceder a esta web",
  "activation": "Activación",
  "code": "Código",
  "code-sent": "Código enviado",
  "contact": "Contacto",
  "enter": "Entrar",
  "error-text": "Error",
  "mail": "Correo",
  "new-version-available": "Nueva versión disponible",
  "password": "Contraseña",
  "resend-wait": "Espera {{seconds}}s para reenviar",
  "server-apologies": "Disculpen las molestias",
  "server-maintenance": "Servidor en mantenimiento",
  "translation-load-error": "Error al cargar las traducciones",
  "user": "Usuario",
  "user-or-password-incorrect": "Usuario o contraseña incorrecta",
  "wait": "Espere por favor"
}